/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import RecruitmentHeader from "../../../components/common/layout/RecruitmentHeader";
import Header from "../../../components/common/layout/Header";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import PageLoader from "../../../components/common/layout/PageLoader";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Error from "../../../components/common/form/Error";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import CorporateHeader from "../../../components/common/layout/CorporateHeader";
import { dataActions } from "../../../shared/store/data-Slice";

const SiteMap = ({ type }: any) => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const tenant: string = useSelector((state: any) => state.data.tenant);
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false)
    const params = useParams();
    const dispatch = useDispatch();
    useSitemap();

    const getMenu = async () => {
        try {
            setIsError(false)
            setLoading(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.menu}${type === "passenger" ? "passenger-main-menu/" : type === "corporate" ? "corporate-main-menu/" : "recruitment-main-menu/"}`);

            if (res && res?.status === 200) {
                setData(res?.data)
                setLoading(false)
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while feching header menu", error);
        }
    };

    useEffect(() => {
        (!!lang && !!type) && getMenu();
    }, [lang, type])

    const handleNavigate = (item: any, e: any) => {
        if (item?.title === "Recruitment" || item?.title === "भरती" || item?.title === "भर्ती" || item?.title === "Careers" || item?.title === "करियर") {
            e.preventDefault()
            const protocol = window.location.protocol;
            const www = window.location.host?.includes("www.") ? true : false;
            const host = www ? window.location.host?.replace("www.", "") : window.location.host;
            let currentHost: any = !!tenant ? host?.replace(`${tenant}.`, "") : host;
            const newUrl: any = tenant === url?.subdomain?.recruitment ? `${protocol}//${currentHost}` : `${protocol}//${url?.subdomain?.recruitment}.${currentHost}`;
            if (params?.lang) {
                window.location.href = `${newUrl}/${params?.lang}`;
            } else {
                window.location.href = newUrl;
            }
        }

        if (item?.title === "Vigilance Complaints" || item?.title === "सतर्कता शिकायतें" || item?.title === "दक्षता तक्रारी") {
            e.preventDefault()
            const protocol = window.location.protocol;
            const www = window.location.host?.includes("www.") ? true : false;
            const host = www ? window.location.host?.replace("www.", "") : window.location.host;
            let currentHost: any = !!tenant ? host?.replace(`${tenant}.`, "") : host;
            const newUrl: any = tenant === url?.subdomain?.vigilance ? `${protocol}//${currentHost}` : `${protocol}//${url?.subdomain?.vigilance}.${currentHost}`;
            if (params?.lang) {
                window.location.href = `${newUrl}/${params?.lang}`;
            } else {
                window.location.href = newUrl;
            }
        }
    }

    const handleLink = (url: any) => {
        dispatch(dataActions.setWebOpen(true));
        dispatch(dataActions.setLink(url));
    }


    return (
        <>
            <Helmet>
                <title>{t("seo_friendly.site_map.title")}</title>
                <meta name="description" content={t("seo_friendly.site_map.desc")} />
            </Helmet>
            <div className={`bg-white dark:bg-bgDarkDull ${type === "corporate" ? "mb-[30px] lg:mb-[50px]" : ""}`}>
                {type === "corporate" ?
                    <div className="w-full h-[240px] xlx:h-[315px] relative">
                        <div className="relative w-full h-full">
                            <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full" style={{ background: "linear-gradient(87deg, #162340 28%, rgba(22, 35, 64, 0.00) 94.38%)" }}></div>
                            <img src={require("../../../assets/images/pattern3.png")} alt="pattern" className="absolute top-0 left-0 bottom-0 z-[1] h-full" />
                            <img src={require("../../../assets/images/pages4.png")} alt="bg-image" className="w-full h-full object-cover" />
                        </div>
                        <div className="absolute top-0 left-0 right-0 bottom-0 items-start justify-between w-full flex flex-col pb-[58px] sm:pb-[45px] mms:pb-[40px] lgs:pb-[35px] xlx:pb-[60px] h-full z-[2]">
                            <div className="w-full h-fit">
                                <CorporateHeader bg={true} blur={true} />
                            </div>

                            <div className="flex container items-center justify-center mms:!px-[30px]">
                                <h2 className="text-white font-bold">{t("header.sitemap")}</h2>
                            </div>
                        </div>
                    </div>
                    : <div className="w-full h-[240px] xlx:h-[285px] relative banner-bg">
                        <img src={theme === "dark" ? require("../../../assets/images/pages3.png") : require("../../../assets/images/pages.png")} alt="bg-image" className="w-full h-full object-cover" />
                        <div className="absolute top-0 left-0 right-0 bottom-0 items-start justify-between w-full flex flex-col pb-[25px] h-full">
                            <div className="w-full h-fit">
                                {type === "passenger" ? <Header type={type} /> : <RecruitmentHeader />}
                            </div>

                            <div className="flex container items-center justify-center md:!px-[30px] xlx:!px-[50px]">
                                <h2 className="text-primaryText dark:text-white font-bold">{t("header.sitemap")}</h2>
                            </div>
                        </div>
                    </div>}
                <div className="container py-[40px] xlx:py-[60px] w-full min-h-[357px]" id="home">
                    {loading ?
                        <PageLoader />
                        :
                        <>
                            {isError ? <Error /> : <div className="w-full h-full grid grid-cols-1 xsm:grid-cols-2 md:grid-cols-3 msm:grid-cols-4 xl:grid-cols-5 gap-y-[30px] gap-x-[85px]">
                                {Array.isArray(data) && data?.map((item: any, index: number) => (
                                    <div className="flex flex-col gap-[15px] xlx:gap-[22px]" key={index}>
                                        <Link to={(item?.url_type !== "external") ? (!!params?.lang ? `${item?.url === "/" ? `/${params?.lang}` : `/${params?.lang + item?.url}`}` : item?.url) : item?.url} target={`${item?.open_in_new_tab ? '_blank' : '_self'}`} className={`${item?.subRoutes?.length > 0 ? "border-b border-[rgba(0,0,0,0.10)] dark:border-[#454545] pb-[15px] xlx:pb-[24px]" : ""} flex flex-col text-[#32435F] dark:text-textBlackDark font-semibold text-[1.375rem] leading-snug uppercase hover:underline focus:underline`} onClick={(e: any) => { if (item?.open_in_new_tab) { if (item?.url_type === "external") { e.preventDefault(); handleLink(item?.url?.replace(`/${lang}/`, "")); } else { window.open(item?.url, '_blank'); } } else { handleNavigate(item, e); } }}>
                                            {item?.title}
                                        </Link>

                                        {item?.subRoutes?.length > 0 &&
                                            <div className='flex flex-col gap-[8px]'>
                                                {Array.isArray(item?.subRoutes) && item?.subRoutes?.map((i: any, idx: number) => (
                                                    <React.Fragment key={idx}>
                                                        {i?.open_in_new_tab ?
                                                            <Link to={`${(i?.url_type !== "external") ? i?.url : i?.url?.replace(`/${lang}/`, "")}`} target='_blank' className="text-[#373737] dark:text-textBlackDull text-base leading-snug font-medium hover:underline focus:underline" onClick={(e: any) => { if (i?.url_type === "external") { e.preventDefault(); handleLink(i?.url?.replace(`/${lang}/`, "")); } else { window.open(i?.url, '_blank'); } }}>{i?.title}</Link>
                                                            :
                                                            <Link to={!!params?.lang ? `/${params?.lang + i?.url?.replace(`/${lang}/`, "")}` : `${i?.url?.replace(`/${lang}/`, "")}`} className="text-[#373737] dark:text-textBlackDull text-base leading-snug font-medium hover:underline focus:underline" onClick={(e) => { handleNavigate(i, e); }}>{i?.title}</Link>

                                                        }
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        }

                                    </div>
                                ))}
                            </div>}
                        </>
                    }
                </div>
            </div>
        </>
    );
};

export default SiteMap;